export default class RightSalary extends HTMLDivElement {

    connectedCallback() {

        this.selectElement.addEventListener("change", this.handleChange);
    }

    handleChange = (e) => {
        const allPanels = this.panels;

        allPanels.forEach(panel => panel.classList.add("d-none"));

        const activePanel = Array.from(allPanels).filter(panel => panel.id == e.target.value);


        if (activePanel != null && activePanel.length > 0) {
            activePanel[0].classList.remove("d-none");
            activePanel[0].querySelector("[is=counter-spinner]")?.reset();
        }
    }

    get selectElement() {
        return this.querySelector("select");
    }

    get panels() {
        return this.querySelectorAll(".right-salary-panel");
    }

}

customElements.define("right-salary", RightSalary, { extends: "div" });